import type { EditorJSONState } from '@core/prosemirror-types';

export const isSSR = (() => {
  try {
    return !window && !document;
  } catch (e) {
    return true;
  }
})();

export const isMacOS = !isSSR ? /Mac/.test(navigator.platform) : false;
export const isApple = !isSSR ? /Mac|iPad|iPhone|iPod/.test(navigator.platform) : false;
export const metaKey = isApple ? '⌘' : 'ctrl';

export const DEFAULT_KEYMAP_INPUTRULE_PRIORITY = 40;
export const EMPTY_SELECTION = Object.seal({
  type: 'text',
  anchor: 0,
  head: 0,
});

export const isEmptyDoc = (state: EditorJSONState) => {
  if (!state?.doc?.content?.length) return true;

  const { content: docContent } = state.doc;
  return docContent.length === 1 && (!docContent[0].content || !docContent[0].content.length);
};

const camelCaseKebabCase = (str: string) => str.replace(/[A-Z]/g, char => `-${char.toLowerCase()}`);

export const cssStyleDeclarationToString = (
  styleDeclaration: Partial<CSSStyleDeclaration>,
): string =>
  Object.entries(styleDeclaration)
    .reduce((acc, [key, value]) => `${acc}${camelCaseKebabCase(key)}: ${value}; `, '')
    .trim();

// https://github.com/angular/angular/blob/main/packages/core/src/sanitization/url_sanitizer.ts#L38
const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:\/?#]*(?:[\/?#]|$))/i;
export function sanitizeUrl(url: string): string | null {
  const stingUrl = String(url);
  if (stingUrl.match(SAFE_URL_PATTERN)) return stingUrl;

  console.warn(`Unsafe URL: ${url}`);
  return null;
}
